export const styleBreakWord = {
  whiteSpace: 'normal',
  wordBreak: 'break-word'
}
